import { Component, Injector, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { AuthQuery } from './modules/auth/state/auth.query';
import { environment } from 'src/environments/environment';
import { catchError, tap } from 'rxjs/operators';
import { SnotifyPosition, SnotifyService } from 'ng-snotify';
import { GeneralService } from './modules/shared/state/general.service';
import { MessageModel } from './modules/crm/modules/messages/models/message.model';
import { CrudService } from './modules/shared/services/crud.service';
import { DialogUtils } from './modules/crm/modules/agenda/helpers/dialog.utils';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { Subject } from 'rxjs';
import * as moment from 'moment';

const STAIRS_ICON = `
<svg id="stairs" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
<g id="Group_86" data-name="Group 86">
  <path id="Path_12" data-name="Path 12" d="M19.414,0H14.707a.586.586,0,0,0-.586.586V4.707H10a.586.586,0,0,0-.586.586V9.414H5.293A.586.586,0,0,0,4.707,10v4.121H.586A.586.586,0,0,0,0,14.707v4.707A.586.586,0,0,0,.586,20H19.414A.586.586,0,0,0,20,19.414V.586A.586.586,0,0,0,19.414,0Zm-.586,18.828H1.172V15.293H5.293a.586.586,0,0,0,.586-.586V10.586H10A.586.586,0,0,0,10.586,10V5.879h4.121a.586.586,0,0,0,.586-.586V1.172h3.535Z"/>
</g>
</svg>
`;

const BATHTUBE_ICON = `
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
  <path id="bath" d="M18.572,12.143v2.143a4.162,4.162,0,0,1-1.428,3.192v2.165a.344.344,0,0,1-.357.357h-.714a.344.344,0,0,1-.357-.357V18.326a4.305,4.305,0,0,1-1.428.246H5.714a4.3,4.3,0,0,1-1.428-.246v1.228a.483.483,0,0,1-.106.318A.318.318,0,0,1,3.928,20H3.214a.317.317,0,0,1-.251-.128.481.481,0,0,1-.106-.318V17.477a4.16,4.16,0,0,1-1.428-3.192V12.142H18.572ZM7.857,7.5a.344.344,0,1,1-.1-.257A.348.348,0,0,1,7.857,7.5Zm.714-.714a.344.344,0,1,1-.1-.257A.348.348,0,0,1,8.572,6.786Zm-.714-.714a.344.344,0,1,1-.1-.257A.348.348,0,0,1,7.857,6.071Zm1.428,0a.344.344,0,1,1-.1-.257A.348.348,0,0,1,9.286,6.071Zm-.714-.714a.344.344,0,1,1-.1-.257A.348.348,0,0,1,8.571,5.357Zm-.714-.714a.344.344,0,1,1-.1-.257A.348.348,0,0,1,7.857,4.642ZM20,10.357v.714a.344.344,0,0,1-.357.357H.357A.344.344,0,0,1,0,11.071v-.714A.344.344,0,0,1,.357,10H1.429V2.857A2.753,2.753,0,0,1,2.266.837,2.752,2.752,0,0,1,4.286,0,2.76,2.76,0,0,1,6.339.871,2.084,2.084,0,0,1,7.433.737a2.118,2.118,0,0,1,1.038.435L8.716.926a.153.153,0,0,1,.246,0l.469.469a.153.153,0,0,1,0,.246l-3.5,3.5a.153.153,0,0,1-.246,0l-.469-.469a.153.153,0,0,1,0-.246l.246-.246A2.111,2.111,0,0,1,5,3.024a2.077,2.077,0,0,1,.263-1.2,1.429,1.429,0,0,0-1.992.028,1.376,1.376,0,0,0-.418,1.01V10H19.643a.344.344,0,0,1,.357.357Zm-10-5A.344.344,0,1,1,9.9,5.1.348.348,0,0,1,10,5.357Zm-.714-.714a.344.344,0,1,1-.1-.257A.348.348,0,0,1,9.286,4.643Zm-.714-.714a.344.344,0,1,1-.1-.257A.348.348,0,0,1,8.571,3.928Zm2.143.714a.344.344,0,1,1-.1-.257A.348.348,0,0,1,10.714,4.643ZM10,3.928a.344.344,0,1,1-.1-.257A.348.348,0,0,1,10,3.928Zm-.714-.714a.344.344,0,1,1-.1-.257A.348.348,0,0,1,9.285,3.214Zm2.143.714a.344.344,0,1,1-.1-.257A.348.348,0,0,1,11.428,3.928Zm-.714-.714a.344.344,0,1,1-.1-.257A.348.348,0,0,1,10.713,3.214Zm1.428,0a.344.344,0,1,1-.1-.257A.348.348,0,0,1,12.142,3.214Z" fill="#242424"/>
</svg>
`;

const BEDS_ICON = `
<svg xmlns="http://www.w3.org/2000/svg" width="20" height="12.5" viewBox="0 0 20 12.5">
  <path id="bed" d="M2.5,7.5H19.375A.634.634,0,0,1,20,8.125V12.5H17.5V10H2.5v2.5H0V.625A.6.6,0,0,1,.186.186.6.6,0,0,1,.625,0h1.25a.6.6,0,0,1,.439.186A.6.6,0,0,1,2.5.625ZM8.125,4.375a2.41,2.41,0,0,0-.732-1.768,2.406,2.406,0,0,0-1.768-.732,2.412,2.412,0,0,0-1.768.732,2.408,2.408,0,0,0-.732,1.768,2.408,2.408,0,0,0,.732,1.768,2.412,2.412,0,0,0,1.768.732,2.406,2.406,0,0,0,1.768-.732A2.41,2.41,0,0,0,8.125,4.375ZM20,6.875V6.25A3.612,3.612,0,0,0,18.9,3.6,3.616,3.616,0,0,0,16.25,2.5H9.375a.634.634,0,0,0-.625.625v3.75Z" fill="#242424"/>
</svg>
`;

const MESSAGE_ICON = `
<svg xmlns="http://www.w3.org/2000/svg" width="36" height="28.285" viewBox="0 0 36 28.285">
  <path id="envelope-o" d="M33.429,25.071V9.643a11.824,11.824,0,0,1-1.386,1.326q-5.384,4.138-8.558,6.79-1.025.864-1.667,1.346a9.241,9.241,0,0,1-1.738.974,5.048,5.048,0,0,1-2.06.492h-.04a5.041,5.041,0,0,1-2.059-.492,9.284,9.284,0,0,1-1.738-.974q-.643-.482-1.667-1.346-3.174-2.652-8.558-6.79A11.824,11.824,0,0,1,2.572,9.643V25.072a.652.652,0,0,0,.643.643H32.786a.652.652,0,0,0,.643-.643Zm0-21.114V3.465l-.01-.261-.06-.251-.11-.181-.181-.151-.281-.05H3.214a.652.652,0,0,0-.643.643,7.031,7.031,0,0,0,2.953,5.7Q9.4,11.973,13.58,15.287q.121.1.7.593t.924.753q.342.26.894.633a5.252,5.252,0,0,0,1.015.553A2.411,2.411,0,0,0,17.98,18h.04a2.377,2.377,0,0,0,.864-.181,5.393,5.393,0,0,0,1.015-.552q.553-.371.893-.633t.924-.753q.584-.491.7-.593Q26.6,11.973,30.475,8.92A9.444,9.444,0,0,0,32.494,6.6a5.024,5.024,0,0,0,.935-2.642ZM36,3.214V25.071a3.223,3.223,0,0,1-3.214,3.214H3.214a3.1,3.1,0,0,1-2.27-.944A3.1,3.1,0,0,1,0,25.071V3.214A3.1,3.1,0,0,1,.944.944,3.1,3.1,0,0,1,3.214,0H32.785a3.1,3.1,0,0,1,2.27.944A3.1,3.1,0,0,1,36,3.214Z" fill="#fff"/>
</svg>
`;

const ALARM_ICON = `
<svg xmlns="http://www.w3.org/2000/svg" width="21.875" height="25" viewBox="0 0 21.875 25">
  <g id="bell-fill" transform="translate(-2.25 -0.001)">
    <path id="Path_24" data-name="Path 24" d="M13.188,25a3.125,3.125,0,0,0,3.125-3.125h-6.25A3.125,3.125,0,0,0,13.188,25ZM14.743,1.718a1.563,1.563,0,1,0-3.11,0A7.816,7.816,0,0,0,5.375,9.375c0,1.716-.781,9.375-3.125,10.938H24.125C21.782,18.751,21,11.091,21,9.375A7.815,7.815,0,0,0,14.743,1.718Z" transform="translate(0 0)" fill="#fff"/>
  </g>
</svg>

`;

const BELL_ICON = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-bell" viewBox="0 0 16 16">
<path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z"/>
</svg>`
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'crm-immobiliare';

  constructor(translate: TranslateService, iconRegistry: MatIconRegistry, sanitizer: DomSanitizer,
    private afMessaging: AngularFireMessaging, private http: HttpClient, private authQuery: AuthQuery,
    private snotifyService: SnotifyService, private generalService: GeneralService,
    private crudService: CrudService<MessageModel>, private _overlay: Overlay, private injector: Injector,) {
    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('it-IT');

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('it-IT');

    registerLocaleData(localeIt, 'it');

    iconRegistry.addSvgIconLiteral('stairs', sanitizer.bypassSecurityTrustHtml(STAIRS_ICON));
    iconRegistry.addSvgIconLiteral('bathtube', sanitizer.bypassSecurityTrustHtml(BATHTUBE_ICON));
    iconRegistry.addSvgIconLiteral('beds', sanitizer.bypassSecurityTrustHtml(BEDS_ICON));
    iconRegistry.addSvgIconLiteral('message', sanitizer.bypassSecurityTrustHtml(MESSAGE_ICON));
    iconRegistry.addSvgIconLiteral('bell', sanitizer.bypassSecurityTrustHtml(BELL_ICON));
    iconRegistry.addSvgIconLiteral('alarm', sanitizer.bypassSecurityTrustHtml(ALARM_ICON));
  }

  ngOnInit(): void {

    this.afMessaging.requestToken
      .subscribe(
        (token) => {
          this.http.post<any>(`${environment.api.url}/api/v1/auth/set_fcm_token`, { token }, {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
            })
          }).subscribe(
            () => { },
            error => {
              console.error(error);
            },
            () => { });
        },
        (error) => { console.error(error); },
      );
    this.afMessaging.messages
      .subscribe((message: any) => {

        console.log("received message")
        console.log(message)
        this.crudService.count('message', { read: { value: false, matchMode: 'match' } }, { direction: 'received' })
          // tslint:disable-next-line: deprecation
          .subscribe(
            (count: number) => {
              this.generalService.setMessageCount(count);
            },
            error => {
            },
            () => {
            });
        if (message.data.type === 'message') {
          DialogUtils.openPostItOverlay(event, -200, -200, this._overlay,
            this.injector, message.data.id, message.notification.title, message.notification.body, message);
        }
        if (message.data.type === 'notification') {
          this.generalService.addNotification(message);
          var date = moment(message.notification.title);
          this.snotifyService.html(`<div><b>${date.format('DD/MM/YYYY HH:mm')}</b></div>
         <div class="snotifyToast__body">${message.notification.body}</div> `, {
            timeout: 60000,
            showProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            position: SnotifyPosition.rightBottom
          });
        }
        if (message.data.type === 'update') {
          if (message.data.read == 'true') {
            this.generalService.setMessagesIdToClose(message.data.id)
          }
          if (message.data.read == 'false') {
            DialogUtils.openPostItOverlay(event, -200, -200, this._overlay,
              this.injector, message.data.id, message.notification.title, message.notification.body, message);
          }

        }
      });
  }
}

